<template>
  <div class="job-details-container">
    <b-button @click="openLogs" size="-tab" variant="-gray"
              :class="{ 'btn--primary': tab === 0 }">{{$t('printers.modal.jobDetails.logs')}}
    </b-button>
    <b-button @click="openSettings" size="-tab" variant="-gray"
              :class="{ 'btn--primary': tab === 1 }">{{$t('printers.modal.jobDetails.settings')}}
    </b-button>
    <b-button @click="tab=2" size="-tab" variant="-gray"
              :class="{ 'btn--primary': tab === 2 }">{{$t('printers.modal.jobDetails.timelaps')}}
    </b-button>
    <b-tabs v-model="tab">
      <!-- Logs -->
      <b-tab class="job-detail-tab">
        <container-loader v-if="!logsLoaded"></container-loader>
        <p v-else-if="logs.length > 0" class="text--code" v-html="logText"></p>
        <div v-else class="empty-tab-content">{{logsMessage}}</div>
      </b-tab>

      <!--Slicing settings-->
      <b-tab class="job-detail-tab">
        <container-loader v-if="!settingsLoaded"></container-loader>
        <b-form-textarea v-else-if="settings.length > 0" id="textarea-plaintext" rows="10" plaintext :value="settings"></b-form-textarea>
        <div class="empty-tab-content" v-else>{{settingsMessage}}</div>
      </b-tab>

      <!-- Timelaps -->
      <b-tab class="job-detail-tab">
        <div v-if="job.gif_image" style="width: 100%; text-align: center;">
          <video controls width="400" height="300">
            <source type="video/mp4" :src="videoSrc" >
          </video>
        </div>
        <div class="empty-tab-content" v-else>{{$t('printers.modal.jobDetails.noTimelaps')}}</div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import Printer from '@/mixins/printer';

  export default {
    name: 'job-details',
    props: {
      printerId: {
        type: [Number, String],
        required: true
      },
      job: {
        type: Object,
        required: true
      },
      showTimelaps: {
        type: [Boolean],
        default: false
      }
    },
    mixins: [Printer],
    data() {
      return {
        tab: -1,
        printer: {},

        settingsLoaded: false,
        settings: '',
        settingsMessage: null,

        logsLoaded: false,
        logs: '',
        logsMessage: null,
      }
    },
    created() {
      const printerIndex = this.getPrinterIndex(this.printerId);
      if (printerIndex >= 0) {
        this.printer = this.getPrinters[printerIndex];
      }
      this.openFirstTab();
    },
    computed: {
      ...mapGetters(['getPrinterIndex', 'getPrinters']),

      jobId() {
        return this.job.job_id !== undefined ? this.job.job_id : this.job.id;
      },
      logText() {
        return this.logs.replace(/(?:\r\n|\r|\n)/g, '<br />');
      },
      videoSrc() {
        return window.as3Url + 'gif/' + this.job.gif_image;
      }
    },
    methods: {
      ...mapActions(['getJobSlicingSettings', 'getJobLogs']),

      openFirstTab() {
        if (this.showTimelaps) {
          this.tab = 2;
        } else {
          this.openLogs();
        }
      },

      openSettings() {
        this.tab = 1;
        if (!this.settingsLoaded) {
          if (this.job.file_type_id != 2) {
            this.settingsLoaded = true;
            this.settingsMessage = this.$t('printers.modal.jobDetails.settingsUnavailable');
            return;
          }
          this.getJobSlicingSettings(this.jobId).then(({data}) => {
            this.settingsLoaded = true;
            if (data.result) {
              if (data.message) {
                this.settings = JSON.stringify(data.message, null, 2);
              } else {
                this.settingsMessage = this.$t('printers.modal.jobDetails.noSettings');
              }
            } else {
              this.settingsMessage = this.$t('printers.modal.jobDetails.errorLoadingSettings');
            }
          }).catch(() => {
            this.settingsLoaded = true;
            this.settingsMessage = this.$t('printers.modal.jobDetails.errorLoadingSettings');
          })
        }
      },

      openLogs() {
        this.tab = 0;
        if (!this.logsLoaded) {
          this.getJobLogs(this.jobId).then(({data}) => {
            this.logsLoaded = true;
            if (data.result) {
              if (data.message.text.trim()) {
                this.logs = data.message.text;
              } else {
                this.logsMessage = this.$t('printers.modal.jobDetails.noLogs');
              }
            } else {
              this.logsMessage = this.$t('printers.modal.jobDetails.errorLoadingLogs');
            }
          }).catch(() => {
            this.logsLoaded = true;
            this.logsMessage = this.$t('printers.modal.jobDetails.errorLoadingLogs');
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .job-details-container {
    display: flex;
    flex-wrap: wrap;
  }

  .job-detail-tab {
    min-height: 40vh;
  }

  .empty-tab-content {
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
  }

</style>
